import {Injectable} from '@angular/core';
import { TreeGroupOptionItem, TreeItem } from 'app/original-models/tree-item.model';
import { LevelType, SelectedLevel } from 'app/original-models/level-type.model';
import { ACCESS } from 'app/original-models/access.model';
import { BaseGroup } from 'app/original-models/group-base.model';
import { Utils } from 'app/common/utils';

@Injectable({ providedIn: 'root' })
export class CompanyTreeService {

    constructor() {
    }

    mapTreeItem(model: any,
                type: LevelType,
                isOwner: boolean = false,
                level: number = 0): TreeItem {
        let item = new TreeItem(model);
        item.level = level;
        item.title = model.name;
        item.type = type;
        item.role = (model instanceof BaseGroup) ? (model as BaseGroup).getRoleName() : model.currentUserRole;
        item.isOwner = isOwner;
        let nextLevel = level + 1;

        if (model.companies) {
            let companies = model.companies.filter((item) => {
                return item.isActive;
            }).sort((a, b) => a.order - b.order);
            item.subcategories.push(
                ...(<Array<any>>companies)
                    .map(i => this.mapTreeItem(i, LevelType.Company, isOwner, nextLevel)));
        }
        if (model.subGroups) {
            model.subGroups = model.subGroups.sort((a, b) => a.order - b.order);
            item.subcategories.push(
                ...(<Array<any>>model.subGroups)
                    .map(i =>  this.mapTreeItem(i, LevelType.Group, isOwner, nextLevel)));
        }
        return item;
    }

    getSelected(items: TreeItem[], level: SelectedLevel, result: TreeItem) {
        if (!result && items && items.length > 0 && level) {
            result = items.find(g => g.id === level.id && g.type === level.type);
            if (!result) {
                items.forEach((subgroup) => {
                    result = this.getSelected(subgroup.subcategories, level, result);
                });
            }
        }
        return result;
    }

    getSelectedFromTree(items: TreeGroupOptionItem[], level: SelectedLevel, result: TreeItem) {
        var treeItems = [];
        items.forEach((item) => {
            item.subcategories.forEach((subgroup) => {
                treeItems.push(subgroup);
            });
        });
        return this.getSelected(treeItems, level, result);
    }

    hasCompanies(item: any, result: boolean) {
        if (!result && item && item.subcategories && item.subcategories.length > 0) {
            result = item.subcategories.findIndex(g => g.type === LevelType.Company) >= 0;
            if (!result) {
                item.subcategories.forEach((subgroup) => {
                    result = this.hasCompanies(subgroup, result);
                });
            }
        }
        return result;
    }

    filterByRole(items: TreeItem[]) {
        if (items && items.length > 0) {
            items.forEach((subgroup) => {
                if (subgroup.type === LevelType.Group && subgroup.role === ACCESS.GroupReviewer) {
                    subgroup.subcategories = subgroup.subcategories.filter((s) =>
                        (s.type === LevelType.Group && s.role === ACCESS.GroupReviewer) || (s.role && s.role !== ACCESS.GroupReviewer));
                }
                this.filterByRole(subgroup.subcategories);
            });
        }
    }

    getHigherGroupsFromTree(items: TreeGroupOptionItem[]) {
        var treeItems = [];
        items.forEach((item) => {
            item.subcategories.forEach((subgroup) => {
                treeItems.push(subgroup);
            });
        });
        return treeItems.filter(i => i.type === LevelType.Group);
    }

    getAvailableInterCompanies(tree: any, currentCompanyId: number): { companies: any[], hasInterCompanies: boolean } {
        const groups = this.getHigherGroupsFromTree(tree);
        let companies: any[] = [];
        let hasCompanies = false;


        (groups?.length ? groups : tree).forEach(group => {
            let selected = this.getSelected([group], new SelectedLevel(currentCompanyId, LevelType.Company), null);
            if (selected) {
                const filteredCompanies = Utils.removeElementById([group], currentCompanyId);
                companies.push(...filteredCompanies);
                filteredCompanies.forEach(c => {
                    if (!hasCompanies) {
                        hasCompanies = this.hasCompanies(c, hasCompanies);
                    }
                });
            }
        });

        return { companies, hasInterCompanies: hasCompanies };
    }
}
